import React, { useEffect } from 'react'
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate
} from 'react-router-dom'
import { FetchDataComponent } from './data/FetchDataComponent'
import LandingPage from './landing/LandingPage'
import Login from './login/Login'
import Register from './register/Register'
import Profile from './user/Profile'
import Contractors from './contractors/Contractors'
import CompanyDetails from './company/CompanyDetails'
import Contracts from './contracts/Contracts'
import ForgotPassword from './forgot-password/ForgotPassword'
import UserDetails from './user/UserDetails'
import ChangePassword from './user/ChangePassword'
import { useSelector } from 'react-redux'
import { State } from './types/state'
import Statistics from './statistics/Statistics'
import { AxiosConfigContainer } from './requests/AxiosConfigContainer'
import { ToastProvider } from './toast/Toast'
import LoadingSpinnerProvider from './loading-spinner/LoadingSpinner'
import { HeaderMobile, HeaderNormal } from './header/Header'
import { useIsMobileView } from './hooks/useIsMobileView'

const App = (): JSX.Element => {
  const { username } = useSelector((state: State) => state.user)

  return (
    <>
      <BrowserRouter>
        <AxiosConfigContainer />
        <ToastProvider />
        <LoadingSpinnerProvider />
        <FetchDataComponent />
        <Router username={username} />
      </BrowserRouter>
    </>
  )
}

interface RouterProps {
  username: string | null
}

const Router = ({ username }: RouterProps): JSX.Element => {
  const { isUserStateFetched } = useSelector((state: State) => state.refresh)
  const location = useLocation()
  const navigate = useNavigate()
  const isMobile = useIsMobileView()

  useEffect(() => {
    if (
      isUserStateFetched &&
      username === null &&
      !location.pathname.includes('login') &&
      !location.pathname.includes('register') &&
      !location.pathname.includes('forgot-password')
    ) {
      navigate('/login')
    }
  }, [location, navigate, username, isUserStateFetched])

  return isMobile
    ? (
      <HeaderMobile>
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          {username !== null && (
            <>
              <Route path='/profile' element={<Profile />} />
              <Route path='/contractors' element={<Contractors />} />
              <Route path='/contracts' element={<Contracts />} />
              <Route path='/company-details' element={<CompanyDetails />} />
              <Route path='/user-details' element={<UserDetails />} />
              <Route path='/change-password' element={<ChangePassword />} />
              <Route path='/statistics' element={<Statistics />} />
            </>
          )}
        </Routes>
      </HeaderMobile>
      )
    : (
      <HeaderNormal>
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          {username !== null && (
            <>
              <Route path='/profile' element={<Profile />} />
              <Route path='/contractors' element={<Contractors />} />
              <Route path='/contracts' element={<Contracts />} />
              <Route path='/company-details' element={<CompanyDetails />} />
              <Route path='/user-details' element={<UserDetails />} />
              <Route path='/change-password' element={<ChangePassword />} />
              <Route path='/statistics' element={<Statistics />} />
            </>
          )}
        </Routes>
      </HeaderNormal>
      )
}

export default App
